import auth from "../server/auth";

export const initializeToken = async () => {
  const token = getToken();
  if (token) {
    try {
      await setToken(token);
    } catch (error) {
      await setToken("");
    }
  }
};

export const getToken = () => {
  return localStorage.token;
};

export const setToken = async token => {
  localStorage.token = token;
  auth.token(token);
};

export const getTFAToken = () => {
  return localStorage.tfaToken;
};

export const setTFAToken = tfaToken => {
  if (tfaToken) {
    localStorage.tfaToken = tfaToken;
  } else {
    localStorage.removeItem("tfaToken");
  }
};

export const getSidebarCollapsed = () => {
  return localStorage.sidebarCollapsed;
};

export const setSidebarCollapsed = async sidebarCollapsed => {
  localStorage.sidebarCollapsed = sidebarCollapsed;
};
